import { render, staticRenderFns } from "./ModalContacts.vue?vue&type=template&id=c7f66a1c"
import script from "./ModalContacts.vue?vue&type=script&lang=js"
export * from "./ModalContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports